<template>
  <li class="chat-module-item" v-if="item && item.module && searchCompare" @click.prevent="fetchMessages">
    {{ item.module.name }} ({{ item.countNotModerated }} / {{ item.countTotal }})
  </li>
</template>

<script>
import {createNamespacedHelpers} from "vuex";

const { mapMutations, mapActions, mapGetters } = createNamespacedHelpers('nova')
export default {
  name: "NodeChatTypeItem",
  props: ["item", "type", "searchText", "searchUnread"],
  methods: {
    ...mapActions(['fetchTypeIdMessages', 'selectCurrentTypeItem']),
    fetchMessages(){
      const payload = {
        type: this.type,
        typeId: this.item.typeId,
        params: {},
        page: 1
      }
      this.fetchTypeIdMessages(payload)
      this.selectCurrentTypeItem({
        type: this.type,
        typeId: this.item.typeId
      })
    }
  },
  computed: {
    searchCompare: function() {
      if(this.searchUnread && !this.item.countNotModerated) return false
      if(!this.searchText.length) return true
      if(this.item.module && this.item.module.name){
        return this.item.module.name.toLowerCase().includes(this.searchText.toLowerCase())
      }
      return false
    }
  }
}
</script>

<style scoped>

</style>
